import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { show3dDisabledSnackbarOnce } from '.';

let cachedIsWebGLEnabled: boolean | undefined = undefined;

export function isWebGLEnabled(): boolean {
    if (browser.isMobile) {
        return false;
    }
    if (cachedIsWebGLEnabled !== undefined) {
        return cachedIsWebGLEnabled;
    }
    const canvas = document.createElement('canvas');
    let gl: any;
    try {
        gl = canvas.getContext('webgl') || canvas.getContext('webgl2');
        if (!gl) {
            throw 'gl not enabled';
        }
        cachedIsWebGLEnabled = true;
    } catch (e) {
        cachedIsWebGLEnabled = false;
    }
    if (!cachedIsWebGLEnabled) {
        show3dDisabledSnackbarOnce();
    }
    return cachedIsWebGLEnabled;
}
